

























helpers = require('../../../helpers.coffee')

view_model = {
  components:
    contactsPickerTextCsv: require '../picker/text_csv'
    contactGroupsList: require('../../contact_groups/list.vue')

  props:
    has_groups:
      default: false

  data: ->
    raw_contacts: null
    contact_groups: null
    ignored_groups: []

  methods:
    submit: ->
      EventsBus.$emit 'contacts-picker-text-csv-validate'

    confirmImport: (data)  ->
      Loader.on()
      @raw_contacts = data
      save = if @has_groups then false else true
      @confirmSave(@raw_contacts, save)

    confirmSave: (data, save=true, ignored_groups=null) ->
      successCallback = if save then @successHandler else @confirmationHandler
      @resource.import successCallback, @failureHandler, { data: data.contact_list, save: save, ignored_groups: ignored_groups }

    confirmationHandler: (response) ->
      Loader.off()
      @contact_groups = @parseContactGroups(response) if @has_groups
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-create-groups'

    successHandler: (response) ->
      Loader.off()
      successResponseLabel = this.$t('contacts.label.manuallyInsertSuccessMessage')
      if !@has_groups
        alertify.success this.$t('contacts.feedback.confirmCreate', { length: response.body.contacts.length })
        IntercomCtrl.trackEvent(this.$t('contacts.label.manuallyInsertSuccessTitle'), {
          successResponseLabel : response.data.contacts.length
        })
      else
        alertify.success "Grupos atualizados com sucesso"
        metadata = @createIntercomMetadata(@contact_groups)
        metadata[successResponseLabel] = response.data.contacts.length
        IntercomCtrl.trackEvent(this.$t('contacts_group.label.manuallyInsertSuccessTitle'), metadata)

    failureHandler: (response) ->
      Loader.off()
      alertify.error this.$t('contacts_group.feedback.failOnCreate', { type: if @has_groups then this.$t('contacts_group.label.groups') else this.$t('contacts.label.contacts') })
      EventsBus.$emit 'contacts-picker-text-csv-errors', response.body

    handleGroupSelect: (data) ->
      if data.attr.selected
        index = @ignored_groups.indexOf(data.attr.contact_group.name)
        @ignored_groups.splice(index, 1)
      else
        @ignored_groups.push(data.attr.contact_group.name)

    confirmGroups: ->
      @confirmSave(@raw_contacts, true, @ignored_groups)

    parseContactGroups: (response) ->
      if !response.body.groups
        []
      else
        response.body.groups.map (group) ->
          new ContactGroup
            name: group.name
            import_action: group.import_action
            contacts_count: group.contacts_count

    createIntercomMetadata: (groups) ->
      onExistingGroupsLabel = this.$t('contacts_group.feedback.contactsOnExistingGroups')
      onNewestGroupsLabel = this.$t('contacts_group.feedback.contactsOnNewestGroups')
      metadata = {
        onExistingGroupsLabel: 0,
        onNewestGroupsLabel: 0
      }
      groups.forEach (group) =>
        if group.import_action == "updated"
          metadata[onExistingGroupsLabel] += group.contacts_count
        else
          metadata[onNewestGroupsLabel] += group.contacts_count
      metadata

  created: ->
    company = Session.current_company.id
    @resource = if @has_groups then (new ContactGroupsResource company) else (new ContactsResource company)
    EventsBus.$on 'contacts-picker-text-csv-publish', @confirmImport

  beforeDestroy: ->
    EventsBus.$off 'contacts-picker-text-csv-publish', @confirmImport
}

exports.default = helpers.vue_include(view_model, helpers.contacts.list_view_modes)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/import/manually.vue